import {Component} from '@angular/core';
import {MessageHandlerService} from '@shared/services';
import { AsyncPipe, NgClass } from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

@Component({
    selector: 'message-handler',
    templateUrl: './message-handler.component.html',
    styleUrls: ['./message-handler.component.scss'],
    imports: [
    NgClass,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    AsyncPipe
]
})
export class MessageHandlerComponent {
  public constructor(public messageService: MessageHandlerService) {}

  public dismiss() {
    this.messageService.dismissMessage();
  }
}
